import React, { useEffect, useState } from "react";

const MyEarningCards = (props) => {
  const [cardData, setCardData] = useState([]);
  const [lastSixMonthDate, setLastSixMonthDate] = useState(null);

  // DATE CALCULATIONS
  // start date
  const midnightDate = new Date();
  midnightDate.setHours(0, 0, 0, 0);
  const startDate = midnightDate.toISOString();

  // end date
  const elevenFiftyNinePMDate = new Date();
  elevenFiftyNinePMDate.setHours(23, 59, 0, 0);
  const endDate = elevenFiftyNinePMDate.toISOString();

  useEffect(() => {
    fetchDashboardData();
    getLastSixMonthsStartDate();
  }, []);

  const fetchDashboardData = (params) => {
    let payload = {
      ...params,
    };
    // props.apis.apiGetConnectorLeadCounts(payload).then((res) => {
    //   console.log({ apiGetConnectorLeadCounts: res });
    //   setCardData(res);
    // });
  };

  const handleDateChange = (value) => {
    let val = value[0].key;
    console.log({ value });
    let payload = {};
    if (val === "last_six_month") {
      payload.startDate = lastSixMonthDate;
      payload.endDate = endDate;
    } else {
      payload.startDate = startDate;
      payload.endDate = endDate;
    }
    fetchDashboardData(payload);
  };

  const getLastSixMonthsStartDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // Months are zero-based
    let startMonth = month - 6;
    let startYear = year;

    if (startMonth <= 0) {
      startMonth = 12 + startMonth;
      startYear--;
    }

    const isoDate = new Date(startYear, startMonth - 1, 1).toISOString();
    setLastSixMonthDate(isoDate);
  };

  return (
    <>
      <div className="dashboard_card_container mb-4">
        <div className="metrics_card_row gcol-lg-3">
          <div className="leads_detail_select_box floating_box">
            <div className="row justify-content-end">
              <div className="col-12 col-md-3 col-xl-2">
                <AppInput
                  type="select"
                  options={_enum.OVERALL_DETAIL}
                  name="leads_detail"
                  onChange={(...args) => handleDateChange(...args)}
                  defaultValue={"today"}
                  placeholder="Select"
                ></AppInput>
              </div>
            </div>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.personSinglePinkIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">{cardData?.totalLeads || "-"}</h5>
              <div className="bottom_content">
                <p className="card-text pe-4">Leads Entered</p>
              </div>
            </div>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.personCheckGreenIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">{cardData?.openLeads || "-"}</h5>
              <div className="bottom_content">
                <p className="card-text">Open Leads</p>
              </div>
            </div>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.personStarredIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">{cardData?.actionedLeads || "-"}</h5>
              <div className="bottom_content">
                <p className="card-text">Actioned Leads</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(MyEarningCards);
